<template>
  <div>
    <div v-if="switcherMode">
      <p class="price" v-style:color="priceModel.highlightColor">
        <span
          v-if="(!yearAboVal && priceModel.price === 0) || (yearAboVal && priceModel.price1Y === 0)">Kostenlos</span>
        <br v-if="(!yearAboVal && priceModel.price === 0) || (yearAboVal && priceModel.price1Y === 0)"/>
        <span v-if="yearAboVal && priceModel.price1Y !== 0">{{ priceModel.price1Y | currency }} / Jahr <br/></span>
        <span v-if="!yearAboVal && priceModel.price !== 0">{{ priceModel.price | currency }} / Monat</span>
      </p>
      <v-switch v-model="yearAboVal"
                :color="$finColors.primaryDark"
                :false-value="false"
                :true-value="true"
                class="mt-0 pt-0 mx-2 year-switch"
                :style="priceModel.price === 0 ? 'visibility: hidden' : ''"
                hide-details
                inset>
        <template v-slot:label>
          <span style="hyphens: none;">
            Jährliche Zahlung {{ priceModel.price !== 0 ? '(Einmalzahlung, 1&nbsp;Monat&nbsp;gratis)' : '' }}
          </span>
        </template>
      </v-switch>
    </div>
    <div v-else
         :style="$vuetify.breakpoint.sm ? 'min-height: 120px' : 'min-height: 95px'">
      <p class="pa-0 ma-0">
        <span class="price" v-style:color="priceModel.highlightColor"
              v-if="priceModel.price === 0">Kostenlos<br/></span>
        <span class="price" v-if="priceModel.price1Y === 0"><br/></span>

        <span class="price" v-style:color="priceModel.highlightColor"
              v-if="priceModel.price !== 0">{{ priceModel.price | currency }} / Monat<br/></span>

        <span>{{ priceModel.price1Y !== 0 ? 'Jährliche Zahlung' : '' }}<br/></span>
        <span>{{ priceModel.price1Y !== 0 ? '(Einmalzahlung, 1&nbsp;Monat&nbsp;gratis)' : '' }}<br/></span>
        <span class="price" v-style:color="priceModel.highlightColor"
              v-if="priceModel.price1Y !== 0">{{ priceModel.price1Y | currency }} / Jahr <br/></span>
      </p>
    </div>
  </div>
</template>


<script>

export default {
  name: "FinPriceSwitcher",
  props: {
    priceModel: {
      type: Object,
    },
    switcherMode: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      yearAboVal: false,
    }
  },
  watch: {
    yearAboVal() {
      this.$emit('changeAboDuration', this.yearAboVal)
    }
  }
}
</script>

<style lang="scss" scoped>

.price {
  font-size: 18px;
  font-weight: bold;
}

</style>
